<template>
  <div class="basic">
    <el-form>
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in basic.fields"
          :key="item.id"
          :span="24"
        >
          <field-item
            :index="index"
          />
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { guid } from '../util/helpers'
import FieldItem from './FieldItem'

export default {
  name: 'Basic',

  components: {
    FieldItem
  },

  data () {
    return {
      fieldName: '',
      filedValue: '',
      filedType: 'text',
      showDialog: false,
      showAlert: false
    }
  },

  computed: {
    ...mapState(['basic'])
  }
}
</script>
